import * as j from '@mojotech/json-type-validation';

export const NormaliseEndpointResponseDecoder: j.Decoder<string> = j
  .object({
    phone_number: j.string(),
  })
  .map((item) => item.phone_number);
